module.exports = __webpack_public_path__ + "img/camera.e0c1342a.svg";